export interface IDevice {
  id: string;
  title: string;
  image: string;
  address: string;
  date: string;
}

export const sessionDevicesItems: IDevice[] = [
  {
    id: "0",
    title: "Chrome on iPhone",
    image: "src/mocks/images/chrome.svg",
    address: "222.225.225.222",
    date: "Signed in Nov 17, 2023",
  },
  {
    id: "1",
    title: "Chrome on Macbook Pro",
    image: "src/mocks/images/chrome.svg",
    address: "222.225.225.222",
    date: "Signed in Nov 17, 2023",
  },
  {
    id: "2",
    title: "Safari on Macbook Pro",
    image: "src/mocks/images/safari.svg",
    address: "222.225.225.222",
    date: "Signed in Nov 17, 2023",
  },
  {
    id: "3",
    title: "Safari on Macbook Pro",
    image: "src/mocks/images/safari.svg",
    address: "222.225.225.222",
    date: "Signed in Nov 17, 2023",
  },
  {
    id: "4",
    title: "Safari on Macbook Pro",
    image: "src/mocks/images/safari.svg",
    address: "222.225.225.222",
    date: "Signed in Nov 17, 2023",
  },
];